import { z } from 'zod';

export const schemaConsorsWarmRent = z
    .number()
    .min(0)
    .max(99999)
    .refine(
        (val) => {
            if (val === undefined) return true;
            return /[0-9]{1,13}(\.[0-9]*)?/.test(val.toString());
        },
        { message: 'Invalid characters' },
    );
